import { isTestEnvironment } from '../behaviors/auth-factory';

export const PREVIEW_HOSTNAME = 'konfidens-app-preview.spotify.net';

export const BUILD_COMMIT_HASH =
  typeof document === 'undefined'
    ? undefined
    : document.querySelector<HTMLMetaElement>('meta[name="build-commit"]')
        ?.content;

export const IS_E2E_TEST = isTestEnvironment();
